// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ghns","field":"styles_field__eQLQw","fieldCol":"styles_fieldCol__1vDZX","diffCol":"styles_diffCol__1yZlc","diff":"styles_diff__2s20t"};